import Scan from "~/components/organisms/Scan/Scan";

const SKIN_SCAN_TYPE = "skin";

const SkinScan = () => {
  return <Scan type={SKIN_SCAN_TYPE} />;
};

export default SkinScan;
